import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import CropperImage from "../CropperImage";
import { useIntl } from "react-intl";
import { temp_store } from "../../../modules/function/temp_store"


export const EditDetail = (props) => {
    const intl = useIntl();
    const suhbeader = useSubheader();
    const history = useHistory();
    const state = {};
    const [item_image_path, setItem_image_path] = useState();
    const [nameImageItem_image_path, setNameImageItem_image_path] = useState("");
    const [value, setValue] = useState("xx")
    const [key, setKey] = useState("")
    const [data, setData] = useState([])
    const [textbox, setTextbox] = useState([])
    let [test, setTest] = useState([])
    useEffect(() => {
        /*setValue(props.location.state.row.value)
        setKey(props.location.state.row.itemkey.key)*/
        setTextbox(props.location.state)
        setMapData(props.location.state)

    }, []);



    const setMapData = (data) => {

        let temp = []
        data.map(item => {
            temp.push({
                key_id: item.key_id,
                item_id: item.item_id,
                value: item.value
            })

        })
        setData(temp)
        setTest(temp)
    }

    const setMapEditData = (index, value) => {
        let temp = [...data]
        temp[index] = {
            item_id: temp[index].item_id,
            key_id: temp[index].key_id,
            value: value
        }
        setData(temp)
        console.log(data)
    }

    suhbeader.setTitle(`Edit Detail ${key}`);
    const [stateItem_image_path, setStateItem_image_path] = useState({
        previewItem_image_path: null,
        rawItem_image_path: null,
        imageURLItem_image_path: null,
    });

    const AlertError = (message) => {
        Swal.fire("Menu Management!", message, "error");
    };


    const handleChangeItem_image_path = async (e) => {
        if (e.target.files.length) {
            e.preventDefault();
            let file = e.target.files[0];
            var reader = new FileReader();
            e.target.value = '';
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                var image = new Image();
                image.src = e.target.result;
                image.onload = function () {
                    var height = this.height;
                    var width = this.width;
                    if (height < 512 || width < 512) {
                        Swal.fire(
                            "Upload !",
                            "At least you can upload a 512*512 photo size. !! ",
                            "error"
                        );
                        e.target.value = '';
                        return false;
                    } else {
                        setStateItem_image_path({
                            rawItem_image_path: file,
                            imageURLItem_image_path: e.target.result,
                        });
                        e.target.value = '';
                        return true;
                    }
                };
            };
        }
    };


    const updateFieldChanged = (index, e) => {
        console.log(textbox)
        console.log('index: ' + index);
        console.log('property name: ' + e.target.value);
        let newArr = [...textbox]; // copying the old datas array
        textbox[index].value = e.target.value; // replace e.target.value with whatever you want to change it to
        setTextbox(newArr);
        setMapEditData(index, e.target.value)
    }

    const onSubmit = async () => {
        let apiUrls = `${baseURLV1}/itemDetail`;
        let token = localStorage.getItem("Token");
        console.log(data)
        axios({
            method: "put",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            data: {
                data: data
            }
        }).then(async (res) => {
            history.goBack();
        })
            .catch((err) => {
                Swal.fire(
                    "Edit !",
                    "Your can not update menu. !! " + err,
                    "error"
                );
            });
    };



    return (
        <>
            <Card>
                <CardHeader title={"Edit Detail"}></CardHeader>
                <CardBody>
                    {textbox.map((item, index) => (
                        <div className="form-inline" style={{ marginBottom: "25px" }}>
                            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                                <span style={{ color: "red" }}>
                                    *
                                </span>
                                {intl.formatMessage({ id: "###", defaultMessage: `${textbox[index].itemkey.key}` })}:{" "}
                            </p>
                            <input
                                name="topic"
                                style={{
                                    height: "38px",
                                    width: "530px",
                                    backgroundColor: "#F4F6F9",
                                    borderRadius: "5px",
                                    borderWidth: "0",
                                }}
                                value={textbox[index].value}
                                onChange={
                                    e => updateFieldChanged(index, e)
                                }
                            />

                        </div>
                    ))}
                    <div
                        className="form-inline"
                        style={{
                            marginBottom: "25px",
                        }}
                    >
                        <div
                            style={{
                                marginTop: "15px",
                                float: "left",
                                width: "20%",
                            }}
                        ></div>
                        <button type="button" onClick={() => history.goBack()} className="btn btn-secondary wbt mr-5">
                            {intl.formatMessage({ id: "104047", defaultMessage: "Cancel" })}
                        </button>
                        <button className="btn btn-primary" onClick={() => onSubmit()}>
                            {intl.formatMessage({ id: "104048", defaultMessage: "Save" })}
                        </button>
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
